import isMobilePhone from "validator/lib/isMobilePhone";

export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  return isMobilePhone(phoneNumber);
};
